<script setup lang="ts">
import SessionResultChart from '@/components/game/session-results/SessionResultChart.vue';
import type { SessionResultChartItem } from '@/components/game/session-results/types.js';

interface Props {
    chartData: SessionResultChartItem[];
    suggestion: string | number | null;
    mode: string | number | null;
}

defineProps<Props>();
</script>

<template>
    <div class="flex flex-col gap-2 items-center">
        <SessionResultChart class="px-2" :data="chartData" :recommended-value="suggestion" :most-voted-value="mode" />
        <div class="flex gap-4 px-4 py-2">
            <div class="flex gap-1 items-center">
                <div class="w-2 h-4 rounded-full bg-patilla-600"></div>
                <span class="paragraph-xs font-medium text-foreground-muted">Recommended</span>
            </div>
            <div class="flex gap-1 items-center">
                <div class="w-2 h-4 rounded-full bg-surface-accent-3 border-2 border-manaca-400"></div>
                <span class="paragraph-xs font-medium text-foreground-muted">Most voted</span>
            </div>
        </div>
    </div>
</template>
